module.exports = __webpack_public_path__ + "img/dy.9de22100.png";